import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isModalContactOpen: false,
	pageNotFound: false
};

const siteSlice = createSlice(
	{
		name: 'site',
		initialState,
		reducers: {
			setIsModalContactOpen(state, action) {
				state.isModalContactOpen = action.payload;
			},
			setPageNotFound(state, action) {
				state.pageNotFound = action.payload;
			}
		}
	},
	initialState
);

export const { setIsModalContactOpen, setPageNotFound } = siteSlice.actions;

export default siteSlice.reducer;
